<template>
  <div class="select-contract-number-modal">
    <div class="select-contract-number-modal__form">
      <input-select
        title="Номер договора"
        v-model="contractNumber"
        option-title-key="title"
        option-value-key="value"
        v-bind:options="contracts"
        v-bind:menu-props="{ maxHeight: 140 }"
      />
    </div>
    <div class="select-contract-number-modal__controls">
      <button
        class="select-contract-number-modal__controls__close-btn"
        type="button"
        v-on:click="onClose"
      >Отмена</button>
      <button
        class="select-contract-number-modal__controls__submit-btn"
        type="button"
        v-on:click="onSubmit">
        Выбрать
      </button>
    </div>
  </div>
</template>

<script>
import InputSelect from '@/components/InputSelect.vue';

/**
 * @description Название события отправки.
 * @type {string}
 */
const NAME_EVENT_SUBMIT = 'on-submit';

/**
 * @description Название события закрытие.
 * @type {string}
 */
const NAME_EVENT_CLOSE = 'on_close';

export default {
  name: 'SelectContractNumberModal',
  components: { InputSelect },
  data() {
    return {
      /**
       * @description Номер договора.
       * @type {int}
       */
      contractNumber: null,
    };
  },
  methods: {
    /**
     * @description Обработать событие закрытия.
     * @returns {void}
     */
    onClose() {
      this.contractNumber = null;
      this.$emit(NAME_EVENT_CLOSE);
    },
    /**
     * @description Обработать событие отправки.
     * @returns {void}
     */
    onSubmit() {
      this.$emit(NAME_EVENT_SUBMIT, this.contractNumber);
    },
  },
  props: {
    /**
     * @description Договора.
     * @type Array<Object>
     */
    contracts: {
      required: true,
      type: Array,
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.select-contract-number-modal {
  display: grid;
  row-gap: 40px;
  width: min(100%, 400px);
  padding: 20px;
  &__controls {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px 10px;
    &__submit-btn {
      bottom: 35px;
      right: 25px;
      @include buttons.btn-blue(152px, 42px, 16px);
    }
    &__close-btn {
      bottom: 35px;
      left: 25px;
      @include buttons.btn-transparent(152px, 42px, 16px);
    }
  }
}

@media screen and (max-width: 400px) {
  .select-contract-number-modal {
    padding: 0;
    &__controls {
      flex-direction: column;
      button {
        width: 100%;
      }
    }
  }
}

</style>
